import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import NoticeTextInput from "components/complex/nationalNotice/components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "components/complex/nationalNotice/components/inputs/NoticeGlossaryInput";
import NoticeCpvInput from "components/complex/nationalNotice/components/inputs/NoticeCpvInput";
import NoticeIntegerInput from "components/complex/nationalNotice/components/inputs/NoticeIntegerInput";
import FormTranslationContext from "context/FormTranslationContext";
import annulaReportClasses from "../../constants/annulaReportClasses";
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import AnnualReportNoticeSource from "../../constants/AnnualReportNoticeSource";

function AnnualReportConflictEditForm(
    {
        entry,
        newEntry,
        buttonWorks,
        reportStep,
        formikProps
    }) {
    const {getDict} = useContext(FormTranslationContext)
    const classes = annulaReportClasses();
    return (<>
            <NoticeGlossaryInput
                label={`mmia.${reportStep}.type`}
                id="type"
                formikProps={formikProps}
                items={getDict("MP.MMiA.OrdersType")}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeTextInput
                label={`mmia.${reportStep}.number`}
                id="number"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks || entry.demandId != null}
            />
            <NoticeGlossaryInput
                label={`mmia.${reportStep}.source`}
                id="source"
                formikProps={formikProps}
                items={getDict("MP.MMiA.Source")}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeTextInput
                label={`mmia.${reportStep}.noticeNumber`}
                id="noticeNumber"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeGlossaryInput
                label={`mmia.${reportStep}.orderType`}
                id="orderType"
                formikProps={formikProps}
                items={getDict("ENUM.002")}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeCpvInput
                label={`mmia.${reportStep}.codeCpv`}
                id="codeCpv"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <Collapse in={getObjectValue("source", formikProps.values) === AnnualReportNoticeSource.BZP}>
                <NoticeGlossaryInput
                    className={classes.exceptionChip}
                    label={`mmia.${reportStep}.tenderModeBzp`}
                    id="tenderModeBzp"
                    formikProps={formikProps}
                    items={getDict("ENUM.018_019_BZP")}
                    disabled={buttonWorks.anyWorks}
                />
            </Collapse>
            <Collapse in={getObjectValue("source", formikProps.values) === AnnualReportNoticeSource.TED}>
                <NoticeGlossaryInput
                    className={classes.exceptionChip}
                    label={`mmia.${reportStep}.tenderModeTed`}
                    id="tenderModeTed"
                    formikProps={formikProps}
                    items={getDict("ENUM.018_019_TED")}
                    disabled={buttonWorks.anyWorks}
                />
            </Collapse>
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfCasesOfConflictOfInterest`}
                id="numberOfCasesOfConflictOfInterest"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfDetectedAgreements`}
                id="numberOfDetectedAgreements"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
            <NoticeIntegerInput
                label={`mmia.${reportStep}.numberOfContractorsWithRejectedOffer`}
                id="numberOfContractorsWithRejectedOffer"
                formikProps={formikProps}
                disabled={buttonWorks.anyWorks}
            />
        </>
    )

}

AnnualReportConflictEditForm.propTypes = {
    entry: PropTypes.object.isRequired,
    newEntry: PropTypes.bool,
    buttonWorks: PropTypes.shape({anyWorks: PropTypes.bool.isRequired}).isRequired,
    reportStep: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired
}

export default AnnualReportConflictEditForm;